import * as React from 'react';
import { compose } from 'recompose';
import { useDispatch, useSelector } from 'react-redux';
import { createStyles } from '@material-ui/styles';
import Select from '@material-ui/core/Select';
import { SelectItem, withBaseProps } from '@topconagriculture/react-components';
import { changeLanguage, getCurrentLanguage, getLanguagesList } from '../../store';
const styles = (theme) => createStyles({
    wrapper: {},
    flagIcon: {
        width: 22,
        height: 20,
        borderRadius: theme.common.borderRadius.default,
        marginRight: theme.space.margin.small,
    },
    languageSelector: {
        display: 'flex',
        alignItems: 'center',
    },
    languageSelectorSelect: {
        padding: `${theme.space.padding.smallest}px ${theme.space.padding.default}px ${theme.space.padding.smallest}px 0`,
    },
});
const ApplicationLanguageSelect = (props) => {
    const { classes, testId = 'ApplicationLanguageSelect', onChange, imagesBaseUrl = 'https://tapprodstoragecommon.blob.core.windows.net/graphic-resources/assets/images/common/flags/', } = props;
    const dispatch = useDispatch();
    const onChangeHandler = React.useCallback((e) => {
        const languageCode = e.target.value;
        dispatch(changeLanguage.started(languageCode));
        if (onChange) {
            onChange(e, languageCode);
        }
    }, [dispatch]);
    const languages = useSelector(getLanguagesList);
    const selectedLanguage = useSelector(getCurrentLanguage);
    const languageItems = languages.map((languageItem) => (React.createElement(SelectItem, { "data-testid": `${testId}-${languageItem.code}`, key: languageItem.code, value: languageItem.code }, languageItem.short.toUpperCase())));
    return (React.createElement("div", { className: classes && classes.languageSelector, "data-testid": `${testId}` },
        React.createElement("img", { alt: 'language', className: classes.flagIcon, src: `${imagesBaseUrl}${selectedLanguage}.svg` }),
        React.createElement(Select, { "data-testid": `${testId}-input`, value: selectedLanguage || '', onChange: onChangeHandler, classes: { root: classes.languageSelectorSelect } }, languageItems)));
};
const ComposedApplicationLanguageSelect = compose(withBaseProps({ styles }))(ApplicationLanguageSelect);
ComposedApplicationLanguageSelect.displayName = 'ApplicationLanguageSelect';
export default ComposedApplicationLanguageSelect;
//# sourceMappingURL=ApplicationLanguageSelect.js.map